var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBadgeFailure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 146,
    viewBox: "0 0 132 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.125 90C28.125 55.8274 55.8274 28.125 90 28.125C124.173 28.125 151.875 55.8274 151.875 90C151.875 124.173 124.173 151.875 90 151.875C55.8274 151.875 28.125 124.173 28.125 90ZM90 16.875C49.6142 16.875 16.875 49.6142 16.875 90C16.875 130.386 49.6142 163.125 90 163.125C130.386 163.125 163.125 130.386 163.125 90C163.125 49.6142 130.386 16.875 90 16.875ZM77.1025 69.1475C74.9058 66.9508 71.3442 66.9508 69.1475 69.1475C66.9508 71.3442 66.9508 74.9058 69.1475 77.1025L81.5147 89.4697C81.8076 89.7626 81.8076 90.2374 81.5147 90.5303L69.1475 102.898C66.9508 105.094 66.9508 108.656 69.1475 110.852C71.3442 113.049 74.9058 113.049 77.1025 110.852L89.4697 98.4853C89.7626 98.1924 90.2374 98.1924 90.5303 98.4853L102.898 110.852C105.094 113.049 108.656 113.049 110.852 110.852C113.049 108.656 113.049 105.094 110.852 102.898L98.4853 90.5303C98.1924 90.2374 98.1924 89.7626 98.4853 89.4697L110.852 77.1025C113.049 74.9058 113.049 71.3442 110.852 69.1475C108.656 66.9508 105.094 66.9508 102.898 69.1475L90.5303 81.5147C90.2374 81.8076 89.7626 81.8076 89.4697 81.5147L77.1025 69.1475Z",
    fill: "#B4371B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBadgeFailure);
export default __webpack_public_path__ + "static/media/icon-badge-failure.08ac309f502653148648119089ee879b.svg";
export { ForwardRef as ReactComponent };